import { Input } from "antd";
import React, { useState, useRef, useContext, useEffect } from "react";
import toast from "react-hot-toast";
import { APIProviderContext } from "../api";
import Loader from "../loader";
import { useParams, useNavigate } from "react-router-dom";
import { TASK_STATUS } from "../../lib/utils";

function QueueDisplay({}) {


  const { queueID } = useParams();

  const { apiAction } = useContext(APIProviderContext);
  const [loading, setLoading] = useState(false);
  const [queueData, setQueueData] = useState({});

  const navigate = useNavigate();

  useEffect(() => {

    var interval;
    
    if(queueID){
      setLoading(true);
      apiAction("GET", `task/details/${queueID}`)
        .then(data => {
          setQueueData(data?.queueData);
          setLoading(false);

          if(
            data?.queueData?.status === TASK_STATUS.PROCESSING || 
            data?.queueData?.status === TASK_STATUS.PENDING ||
            data?.queueData?.status === TASK_STATUS.COMPLETED && data?.queueData?.rank === 1
          ){
            interval = setInterval(() => {
              apiAction("GET", `task/details/${queueID}`)
                .then(data => {
                  setQueueData(data?.queueData);

                  if(
                    data?.queueData?.status === TASK_STATUS.COMPLETED
                  ){
                    clearInterval(interval);
                  }

                })
                .catch(err => {
                  toast.error("Failed to fetch queue data");
                  console.error(err);
                });
            }, 5000);

          }
        })
        .catch(err => {
          toast.error("Failed to fetch queue data");
          console.error(err);
          setLoading(false);
        });
    }

    return () => {
      if(interval){
        clearInterval(interval);
      }
    };

  }, [queueID]);

  

  
  return (
    <div className="w-full flex flex-col gap-4 text-center">
      {
        loading ? (
          <>
            <Loader 
                size={6}
            />
          </>
        ) : (
          <>
            {
              queueData?.status === TASK_STATUS.PENDING && (
                <>
                <p className="text-[28px]">
                  You are #{queueData?.rank} in the queue. You&apos;ll be up soon for the photo mosaic.
                </p>
                <p>
                    Get your camera ready to take a picture of the photo mosaic
                </p>
                <button 
                  onClick={() => {
                    navigate("/");
                  }}
                  className="ep-action-btn">
                  Finish
                </button>
                </>
              )
            }
            {
              queueData?.status === TASK_STATUS.PROCESSING && (
                <>
                <p className="text-[28px]">
                  You&apos;re up next. We are creating a personalized experience for you. 
                </p>
                <p>
                    Get your camera ready to take a picture of the photo mosaic
                </p>
                </>
              )
            }
            {
              queueData?.status === TASK_STATUS.COMPLETED && (
                <>
                <div className="flex-1 flex flex-col items-center justify-center text-center">
                    <h1 className="text-3xl font-semibold mb-8">Thank you</h1>
                    <div className="mb-4">
                      <p className="text-lg mb-2">Your photo has been</p>
                      <p className="text-lg mb-4">successfully uploaded and is now part of the photomosaic.</p>
                      {/* <p className="text-[16px] mb-2">To see your position in the mosaic, visit:</p> */}
                      {/* <Link to="/" className="text-blue-200 underline mb-6">photomosaic.colorsofmexico.com</Link> */}
                    </div>
                    
                    <div className="rounded-lg w-full max-w-xs">
                      <p className="text-lg font-semibold mb-4">Your Coordinate</p>
                      <div className="bg-white text-blue text-2xl font-bold py-4 px-6 text-center rounded-lg">
                        {queueData?.coordinates}
                      </div>
                    </div>
                    <button 
                      onClick={() => navigate("/look?fill=" + queueData?.coordinates)} 
                      className="w-full text-white text-blue py-3 px-6 font-medium hover:bg-gray-800 transition-colors mt-6 rounded-lg"
                    >
                      View your spot
                    </button>
                  </div>
                </>
              )
            }
          </>
        )
      }
    </div>
  );
}

export default QueueDisplay;